// assets/donation.js
document.addEventListener("DOMContentLoaded", function () {
  // For a left-side button, use Left = "1%" and Right = "unset".
  // For a right-side button, use Right = "1%" and Left = "unset".
  const Right = "1%";
  const Bottom = "12%";
  const Left = "unset";
  const Top = "unset";
  const letterSpacing = "0px";
  const paddingTopBottom = "10px";
  const paddingLeftRight = "15px";
  const fontSize = "20px";

  const currentUrl = encodeURIComponent(window.location.href);
  const apiKey = "2s1ydpemjts60oz92r";

  const script = document.createElement("script");
  script.src = `https://cdn.giveplease.co/donationWidget.js?apiKey=${apiKey}&browserUrl=${currentUrl}&moveBtnRight=${Right}&moveBtnBottom=${Bottom}&moveBtnLeft=${Left}&moveBtnTop=${Top}&letterSpacing=${letterSpacing}&paddingLeftRight=${paddingLeftRight}&paddingTopBottom=${paddingTopBottom}&fontSize=${fontSize}`;
  script.async = true;

  document.body.appendChild(script);
});